import { HANDLE_USER_PROFILE_PICTURE_SELECTION } from './profile-picture.actions';
import {
    UserProfilePictureState, SelectProfilePictureAction
} from './profile-picture.types';

export const USER_PROFILE_PICTURE = 'userProfilePicture';

export const INITIAL_USER_PROFILE_PICTURE_STATE: UserProfilePictureState = {
    data: { profilePicture: '' },
    isLoading: false,
    isError: false,
    isSuccess: false,
    error: null
};

export const userProfilePictureReducer = (
    state: UserProfilePictureState = INITIAL_USER_PROFILE_PICTURE_STATE,
    action: SelectProfilePictureAction) => {
    switch(action.type) {
    case HANDLE_USER_PROFILE_PICTURE_SELECTION: {
        const { profilePicture } = action.payload;

        return {
            ...state,
            data: { profilePicture }
        };
    }

    default:
        return state;
    }
};
